import React from 'react';
import { FormHandles } from '@unform/core';
import { Form as UnformForm } from '@unform/web';

type FormProps = React.ComponentProps<typeof UnformForm>;

export const Form = React.forwardRef<FormHandles, FormProps>(({ noValidate = true, ...rest }, ref) => {
  return <UnformForm ref={ref} noValidate={noValidate} {...rest} />;
});

Form.displayName = 'Form';
